import React from "react";
import {Routes, Route, Link} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";


import Slizer from "./components/slizer";
import Leaderboard from "./components/leaderboard-list";
import User from "./components/user";

import dotenv from "dotenv"

import DarkModeToggleButton from "./darkmode/dark-mode-toggle-button";

import './App.scss';

dotenv.config()

// Graphics assets
// actually screw this if the import fails the whole app fucking dies
//import slizer_title from "./assets/Slizer_Logo_Thin.png"
// You can add a check but it's so fucking long
let slizer_title
const filename = "Slizer_Logo_Thin.png"
try{
   slizer_title = require(`./assets/${filename}`) || null
}
catch(e)
{
  slizer_title = "FUCK";
}

function App() {

  const [user, setUser] = React.useState(null);

  async function login(user = null){
    setUser(user);
  }

  async function logout()
  {
    setUser(null);
  }

  return (
    <div className = "container" style ={{minWidth: 400}}>
      {/* Static elements */}
      <div style = {{display: "flex", justifyContent: "center", alignItems:'center', paddingTop: 20}}>
        <Link to = {"/"}><img id = "slizer_logo" src={"./Slizer_Logo_Thin.png"} alt="Slizer Title Card" style={{height: 80, justifySelf: "center"}}/></Link>

      </div>
      {/* WHY IS THERE NOT AN OPTION TO CHECK IF THE IMAGE EXISTS? IT'S EITHER IMAGE SUCCESSFULLY LOADS OR YOU GET A FUCKING COMPILE ERROR FUCK */}
      {/* <img src={slizer_title.default} alt="Slizer Title Card" style={{width: 100, height: 100}}/> */}
      
      <div className = "container mt-3">
        <Routes>
          <Route path={"/"} />
          <Route path={"/leaderboard"} element={<Leaderboard/>} ></Route>
          <Route path ="/user/:username" element= {<User/>} />
        </Routes>
      </div>

      <Slizer/>

      {/* Footer */}
      <hr/>
      <div style = {{display: "flex", justifyContent: "center", alignItems:'center', margin: "auto"}}>
        <a href="https://apps.apple.com/us/app/slizer/id1306727275">
          <img src={"./get_app_store.svg"} alt="Go to App Store" style={{width:192, height:64}} />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.KhanhLe.Slizer">
          <img src={"./get_on_googleplay.png"} alt="Go to Google Play" style={{width:192, height:64}} />
        </a>
      </div>
      <div style = {{textAlign: "center", justifyContent: "center", alignItems:'center', margin: "auto"}}>
        <br/><h6>Website and game developed by <a target="_blank" href = "https://khanhc.com">Le Vu Nguyen Khanh</a>. Made with ReactJS, NodeJS, Express, MongoDB.</h6>
        <DarkModeToggleButton/>
        </div>
    </div>
  );
}

export default App;
